import { render, staticRenderFns } from "./StoreSetup.vue?vue&type=template&id=1ba3559c&scoped=true&"
import script from "./StoreSetup.vue?vue&type=script&lang=js&"
export * from "./StoreSetup.vue?vue&type=script&lang=js&"
import style0 from "./StoreSetup.vue?vue&type=style&index=0&id=1ba3559c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba3559c",
  null
  
)

export default component.exports